import { useSyncExternalStore } from 'react';

/** The phone layout of nivio-ui.css: below this width the app has a tab bar and a drawer. */
export const PHONE_QUERY = '(max-width: 820px)';

function media(): MediaQueryList | null {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(PHONE_QUERY)
    : null;
}

/** True in the phone layout. Desktop and tablet widths keep their own behaviour. */
export function isPhone(): boolean {
  return media()?.matches === true;
}

function subscribe(onChange: () => void): () => void {
  const list = media();
  list?.addEventListener?.('change', onChange);
  return () => list?.removeEventListener?.('change', onChange);
}

/** `isPhone()` that re-renders when the window crosses the phone width. */
export function usePhone(): boolean {
  return useSyncExternalStore(subscribe, isPhone, () => false);
}
